import { FC, useCallback, useEffect } from "react";

import { getRoles, loadRoles } from "../../store/roles";
import { useAppDispatch, useAppSelector } from "../../store/configureStore";

function withRoles(Component: any): FC<any> {
  return function WithRoles(props): JSX.Element {
    const dispatch = useAppDispatch();
    const roles = useAppSelector(getRoles);

    const refreshRoles = useCallback((): void => {
      dispatch(loadRoles() as any);
    }, [dispatch]);

    useEffect(() => {
      refreshRoles();
    }, [refreshRoles]);

    return (
      <Component
        roles={roles.roles}
        rolesLoading={roles.loading}
        rolesError={roles.error}
        refreshRoles={refreshRoles}
        rolesLastUpdated={roles.lastUpdated}
        {...props}
      />
    );
  };
}

export default withRoles;
